import React from 'react';
import "./TournamentHistory.css"
import TournamentFilter from "./TournamentFilter";
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { apiService } from '../../common/apiCallService.js'
import Loading from '../Loading';
import { domain, baseUrl } from "../../common/config.js"
import TournamentHistoryTable from './TournamentHistoryTable';
import i18next from 'i18next'
class TournamentHistory extends React.Component {
    constructor(props) {
        super(props);
        let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = this.props.activeTournyFilter
        this.state = {
            loading: false,
            tournamentAggResult: this.props.tournyDtls.aggResult.length > 0 && this.props.tournyDtls.aggResult[0],
            tournamentFeed: this.props.tournyDtls.tournyDtls.length > 0 && this.props.tournyDtls.tournyDtls,
            pageNumber: 0,
            buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType==='tournament' ? 'MTT' :  this.props.myStatSettings.gameType,
            trnyType: props.tournamentTypeList.length > 0 ? props.tournamentTypeList[0].value : null,
            gameSpeed: props.tournamentSpeedList.length > 0 ? props.tournamentSpeedList[0].value : null,
            tournamentTypeList: props.tournamentTypeList,
            tournamentSpeedList: props.tournamentSpeedList
        }
    }
    componentWillReceiveProps(prevProps, prevState){
    let mysatsGame=this.props.myStatSettings.gameType==='tournament' ? 'MTT' :  this.props.myStatSettings.gameType
      if(mysatsGame !=this.state.feedGameType){
        let { buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType } = prevProps.activeTournyFilter
        this.setState({
         tournamentAggResult:prevProps.tournyDtls.aggResult.length > 0 && prevProps.tournyDtls.aggResult[0],
         tournamentFeed: prevProps.tournyDtls.tournyDtls.length > 0 && prevProps.tournyDtls.tournyDtls,
         pageNumber: 0,
         buyIn, gameSubType, trnyType, gameSpeed, dateRange, feedGameType: this.props.myStatSettings.gameType==='tournament' ? 'MTT' :  this.props.myStatSettings.gameType,
         trnyType: prevProps.tournamentTypeList.length > 0 ? prevProps.tournamentTypeList[0].value : null,
         gameSpeed: prevProps.tournamentSpeedList.length > 0 ? prevProps.tournamentSpeedList[0].value : null,
         tournamentTypeList: prevProps.tournamentTypeList,
         tournamentSpeedList: prevProps.tournamentSpeedList
        })
      }
        
    }
    nextPage = (data) => {
        this.setState({ pageNumber: data.selected })
       this.getHandHistory(data.selected)
    }

    componentDidMount() {
        if (this.props.tournamentHistoryFullScreenFlag)
            this.setState({ tournamentAggResult: this.props.tournamentAggResult, tournamentFeed: this.props.tournamentFeed })
        else
            this.setState({ tournamentAggResult: this.props.tournyDtls.aggResult.length > 0 && this.props.tournyDtls.aggResult[0], tournamentFeed: this.props.tournyDtls.tournyDtls.length > 0 && this.props.tournyDtls.tournyDtls })
    }

    getHandHistory = (pageNumber) => {
        this.setState({ loading: true, pageNumber: pageNumber })
        let { gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange } = this.state
        apiService(baseUrl + '/tournamentFeed/getTournamentFeedDtls', {
            accountName: localStorage.getItem('accountName'),
            limit: 5, offset: 5 * pageNumber,
            gameSubType, feedGameType, trnyType, buyIn, gameSpeed, dateRange, pageNumber
        }, (data) => {
            if (this.state.pageNumber === 0) {
                this.setState({
                    tournamentAggResult: data.aggResult.length > 0 && data.aggResult[0],
                    tournamentFeed: data.tournyDtls.length > 0 && data.tournyDtls,
                    loading: false
                })
                document.body.scrollTop = document.documentElement.scrollTop = 0;


            } else {
                this.setState({
                    tournamentFeed: data.tournyDtls.length > 0 && data.tournyDtls,
                    loading: false
                })
                document.body.scrollTop = document.documentElement.scrollTop = 0;

            }
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }, (data) => {
            this.setState({ loading: false })
        })

    }

    toggleOpenDetails = () => {
        this.props.toggleTournamentHistoryDetails(!this.props.tournamentHistoryFlag)
    }

    toggleFullScreen = () => {
        this.props.toggleTournamentHistoryFullScreen(!this.props.tournamentHistoryFullScreenFlag)
    }

    saveSetting = (data) => {
        data.feedGameType = this.state.feedGameType
        this.props.setTournyFilter(data)
        this.setState({ pageNumber: 0 })
        this.setState(data, () => this.getHandHistory(0))
    }

    render() {
        let { tournamentTypeList, tournamentSpeedList } = this.props,
            { tournyPlayed, totalBountyWon, totalfee, totalBuyin } = this.state.tournamentAggResult
        return (
            <div className="ms_feed_cards_wrapper " >
                {(this.props.loading || this.state.loading)
                    ? <Loading />
                    :
                    <div className="tournamentCard" style={{ marginBottom: '-100px' }}>
                        <div>
                            <div className="tournamentHeader p-bottom-10-tournament">{i18next.t("lable.tournamentHistory")}
                        {!this.props.tournamentHistoryFullScreenFlag ?
                                    <span className="tournamentIconSpan">
                                        <i data-toggle="modal" data-target="#settingModalTournaments" className="fa fa-filter tournamentColor" style={{ cursor: 'pointer' }}></i>
                                        <i onClick={this.toggleFullScreen} className="tournamentColor marginLeftIconTornament fa fa-arrows-alt" style={{ cursor: 'pointer' }}></i>
                                    </span>
                                    : <span className="tournamentIconSpan">
                                        <button className='crossButton-tournament' style={{ cursor: 'pointer' }} data-toggle="modal" data-target="#settingModalTournaments" >
                                            <FontAwesome className='centre' name='fa fa-filter' style={{ fontSize: '2.5vh', color: 'white' }} />
                                        </button>
                                        <button className='crossButton-tournament' style={{ cursor: 'pointer' }} onClick={this.toggleFullScreen} >
                                            <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '2.5vh', color: 'white' }} />
                                        </button>
                                    </span>}
                            </div>
                            <div className="p-bottom-10-tournament"><span className="tournamentSubHeaderSpan">{i18next.t("lable.total")} - </span> {i18next.t("lable.tournamentsPlayed")}: {tournyPlayed} - {i18next.t("lable.buyIns")}: ${totalBuyin} - {i18next.t("lable.fees")}: ${totalfee}</div>
                        </div>
                        <div className="border-bottom-tournamnet"></div>
                        <div className="row background-tournamnet padding-tournamnet-title table-header-tournamnet">
                            <div style={{ marginBottom: "0" }} className="table-header-width margin-bottom-0">
                                <div className="row table-header-font">
                                    <div style={{ paddingLeft: 0 }} className="col-md-4 col-xs-4" >{i18next.t("lable.tournamentName")}</div>
                                    <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.buyIn")}</div>
                                    <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2" >{i18next.t("lable.startDate")}</div>
                                    <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.fees")}</div>
                                    <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2" >{i18next.t("lable.bountiesWon")}</div>
                                    <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2" >{i18next.t("lable.prizeWon")}</div>
                                    <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.totalWon")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="border-bottom-tournamnet"></div>
                            <TournamentHistoryTable
                                nextPage={this.nextPage}
                                pageNumber={this.state.pageNumber}
                                tournamentAggResult={this.state.tournamentAggResult}
                                tournamentFeed={this.state.tournamentFeed}
                                isFullScreen={false} />
                    </div>}
                <TournamentFilter
                    buyIn={this.state.buyIn}
                    feedGameType={this.state.feedGameType}
                    gameSubType={this.state.gameSubType}
                    trnyType={this.props.tournamentTypeList.length > 0 ? this.props.tournamentTypeList[0].value : ""}
                    gameSpeed={this.props.tournamentSpeedList.length > 0 ? this.props.tournamentSpeedList[0].value : ""}
                    dateRange={this.state.dateRange}
                    tournamentTypeList={this.props.tournamentTypeList}
                    saveSetting={this.saveSetting}
                    tournamentSpeedList={this.props.tournamentSpeedList}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
        tournamentHistoryFullScreenFlag: state.multipleReportCards.tournamentHistoryFullScreenFlag,
        tournyDtls: state.multipleReportCards.tournyDtls,
        tournamentTypeList: state.multipleReportCards.tournytype,
        tournamentSpeedList: state.multipleReportCards.tournySpeed,
        activeTournyFilter: state.multipleReportCards.activeTournyFilter,
        myStatSettings: state.multipleReportCards.myStatSettings,
        lang: state.header.lang
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleTournamentHistoryDetails: (data) => dispatch(actions.toggleTournamentHistoryDetails(data)),
        toggleTournamentHistoryFullScreen: (data) => dispatch(actions.toggleTournamentHistoryFullScreen(data)),
        setTournyFilter: (data) => dispatch(actions.setTournyFilter(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TournamentHistory);



/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/TournamentHistory.js
 **/